var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('img',{class:{'clickable': !!_vm.settings.click},style:(_vm.styles),attrs:{"src":_vm.src},on:{"click":function($event){return _vm.clicked($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }